import axios from 'axios';

const sendRequest = (options) => {
    return new Promise(async (resolve, reject) => {
        try {
            let result = {
                message: '',
                success: false,
            };
            const response = await axios(options);
            if (!response.data) {
                result.message = 'No data received from request';
            } else if (!response.data.success) {
                result.message = response.data.message;
            } else if (!response.data.message) {
                result.message = 'No message received from request';
            } else {
                result.message = response.data.message;
                result.success = true;
            }
            resolve(result);
        } catch (error) {
            console.error('Error processing sendRequest: ', error.response, error);
            reject(error);
        }
    });
};

const getEntities = (api, func, ...args) => {
    const entities = [];

    const pageSize = 500;
    let pageNumber = 1;

    // assume last argument is api opts object
    if (typeof args[args.length - 1] === 'object') {
        args[args.length - 1] = { ...args[args.length - 1], pageSize };
    }
    else {
        args.push({ pageSize });
    }

    const getEntitiesWorker = () => {
        args[args.length - 1].pageNumber = pageNumber;

        return api[func](...args)
            .then((data) => {
                console.log(`${func}, pageSize = ${pageSize}, pageNumber = ${pageNumber}, entities = ${data.entities.length}`);
                entities.push(...data.entities);
                return (pageNumber++ < data.pageCount) ? getEntitiesWorker() : entities;
            });
    }
    return getEntitiesWorker();
};

export default {
    sendRequest,
    getEntities
};